import React, { useContext } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import GridIcon from '@icons/GridIcon';
import ListIcon from '@icons/ListIcon';
import LocationPinIcon from '@icons/LocationPinIcon';
import ViewToggleButton from '../ViewToggleButton';

import { ViewTypeContext } from '@context/viewTypeContext';

const styles = {
    button: {
        outline: 'none',
    },
};

const ViewToggleButtons = ({ displayMap = false, onViewTypeChange }) => {
    const [viewType, setViewType] = useContext(ViewTypeContext);
    const mobileViewToggleButton = classnames(
        'nav-item border-right-0 my-auto hidden-md-up',
        { list: viewType === 'list' },
        { cards: viewType === 'card' }
    );

    return (
        <>
            {/* Mobile List/Grid View Options */}
            <li className={mobileViewToggleButton}>
                <button
                    type="button"
                    className="nav-link"
                    data-toggle="pill"
                    href="#"
                    role="tab"
                    style={styles.button}
                    onClick={() => {
                        const newViewType = viewType === 'list' ? 'card' : 'list';
                        setViewType(newViewType);
                        onViewTypeChange(newViewType);
                    }}
                >
                    <span style={{ visibility: 'hidden' }}>{viewType === 'list' ? 'List' : 'Card'}</span>
                </button>
            </li>

            {/* Desktop List/Grid View Options */}
            <li className="nav-item d-flex align-items-end hidden-sm-down">
                <div className="cards border-right-0 my-auto d-inline-block">
                    <ViewToggleButton
                        Icon={GridIcon}
                        active={viewType === 'card'}
                        onClick={() => {
                            if (viewType === 'card') return;
                            setViewType('card');
                            onViewTypeChange('card');
                        }}
                    />
                </div>

                <div className="list my-auto d-inline-block">
                    <ViewToggleButton
                        Icon={ListIcon}
                        active={viewType === 'list'}
                        onClick={() => {
                            if (viewType === 'list') return;
                            setViewType('list');
                            onViewTypeChange('list');
                        }}
                    />
                </div>

                {displayMap && (
                    <div className="my-auto d-inline-block">
                        <ViewToggleButton
                            Icon={LocationPinIcon}
                            active={viewType === 'map'}
                            onClick={() => {
                                if (viewType === 'map') return;
                                setViewType('map');
                                onViewTypeChange('map');
                            }}
                        />
                    </div>
                )}
            </li>
        </>
    );
};

ViewToggleButtons.propTypes = {
    displayMap: PropTypes.bool,
    onViewTypeChange: PropTypes.func.isRequired,
};

export default ViewToggleButtons;
